// extracted by mini-css-extract-plugin
export default {"container":"Sbjilw","file":"vAYfvv"};